<template>
  <NAPAdvisoryManagement />
</template>
<script>
import NAPAdvisoryManagement from "@/components/matching/NAPAdvisoryManagement.vue";

export default {
  name: "NAPAdvisoryManagementScreen",
  components: {
    NAPAdvisoryManagement,
  },
};
</script>
